import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptArticles} from "./news.adapter";
import type {Article, ArticlesApiResponse} from "./news.types";

export interface GetNewsParams {
  limit?: number;
  page?: number;
}

export const getNewsService = async ({limit, page}: GetNewsParams = {}): Promise<Article[]> => {
  const query: Record<string, number> = {};
  if (typeof limit === "number") query.limit = limit;
  if (typeof page === "number") query.page = page;
  const response = await httpRequest<ArticlesApiResponse>({
    method: "GET",
    url: "/blog/articles",
    baseUrl: config.apiRootUrl,
    query: Object.keys(query).length > 0 ? query : undefined,
  });
  return adaptArticles(response);
};
